export default __webpack_public_path__ + "static/media/CV-RYS.22400360.pdf";